import type { FinalDecision } from '@/types';

const APPROVING: readonly FinalDecision[] = ['APPROVED', 'APPROVED_WITH_ALERTS'];

/**
 * Resolve whether the senior-approval lock applies to this reviewer and this
 * decision.
 *
 * `locked` drives the explanatory banner; `blocked` disables submit. Only
 * approving decisions are blocked — rejecting and escalating stay open, and
 * escalating is how a junior reviewer hands the contract to a senior. The
 * server enforces the same rule in review_senior_guard.py; this just saves a
 * wasted round-trip.
 */
export function resolveSeniorLock(
  requiresSeniorApproval: boolean,
  canApproveSeniorLocked: boolean,
  effectiveDecision: FinalDecision | null,
): { locked: boolean; blocked: boolean } {
  const locked = requiresSeniorApproval && !canApproveSeniorLocked;
  return {
    locked,
    blocked: locked && effectiveDecision !== null && APPROVING.includes(effectiveDecision),
  };
}
